import api from './api';
import type {
  CrmActividad,
  CrmActividadAgendaSearch,
  CrmActividadCreate,
} from '../types/crm';

export interface CrmActividadSearch {
  contactoId?: number;
  oportunidadId?: number;
  soloPendientes?: boolean;
}

const crmActividadService = {
  getAll: async (params: CrmActividadSearch = {}): Promise<CrmActividad[]> => {
    const response = await api.get<CrmActividad[]>('/api/CrmActividades', { params });
    return response.data;
  },

  getAgenda: async (params: CrmActividadAgendaSearch): Promise<CrmActividad[]> => {
    const response = await api.get<CrmActividad[]>('/api/CrmActividades', { params });
    return response.data;
  },

  create: async (dto: CrmActividadCreate): Promise<CrmActividad> => {
    const response = await api.post<CrmActividad>('/api/CrmActividades', dto);
    return response.data;
  },

  setEstado: async (id: number, completada: boolean): Promise<CrmActividad> => {
    const response = await api.put<CrmActividad>(`/api/CrmActividades/${id}/estado`, {
      completada,
    });
    return response.data;
  },

  completar: async (id: number): Promise<CrmActividad> => {
    const response = await api.put<CrmActividad>(`/api/CrmActividades/${id}/completar`);
    return response.data;
  },
};

export default crmActividadService;
